import React from 'react';

const Front = () => (
  <div style={{ padding: 32 }}>
    <h1>Frontend Developer Docs</h1>
    <p>Her kan du legge inn dokumentasjon og ressurser for frontend-utvikling.</p>
  </div>
);

export default Front;
